module.exports = __webpack_public_path__ + "media/custom/images/img22-7a6178c50dc60579d346cdf2952220aa.jpg";